// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AcceptBidPackageUpdatesMutationVariables = Types.Exact<{
  input: Types.AcceptBidPackageIncomingUpdatesInput;
}>;


export type AcceptBidPackageUpdatesMutation = { __typename?: 'Mutation', acceptBidPackageIncomingUpdates: { __typename?: 'BidPackage', id: string } };

export type BidUpdatesAvailable_BidPackageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type BidUpdatesAvailable_BidPackageQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'BidPackageIncomingUpdate', id: string, accepted: boolean, createdAt: Types.Scalars['DateTime']['input'], source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
         }, updateStats: { __typename?: 'BidPackageIncomingUpdateStats', tlivs: { __typename?: 'IncomingChanges', added: number, removed: number, updated: number }, rplvs: { __typename?: 'IncomingChanges', added: number, removed: number, updated: number } } }> } };

export type BidPackagesPage_AvailableUpdateFragment = { __typename?: 'BidPackageIncomingUpdate', id: string, accepted: boolean, createdAt: Types.Scalars['DateTime']['input'], source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
         | null | undefined }
     }, updateStats: { __typename?: 'BidPackageIncomingUpdateStats', tlivs: { __typename?: 'IncomingChanges', added: number, removed: number, updated: number }, rplvs: { __typename?: 'IncomingChanges', added: number, removed: number, updated: number } } };

export type BidPackagesPage_AvailableUpdateProductOfferingFragment = { __typename?: 'ProductOffering', id: string, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   | null | undefined };

export const BidPackagesPage_AvailableUpdateProductOfferingFragmentDoc = gql`
    fragment BidPackagesPage_AvailableUpdateProductOffering on ProductOffering {
  id
  development {
    id
  }
  project {
    id
  }
}
    `;
export const BidPackagesPage_AvailableUpdateFragmentDoc = gql`
    fragment BidPackagesPage_AvailableUpdate on BidPackageIncomingUpdate {
  id
  accepted
  createdAt
  source {
    id
    version
    versionNotes
    readyPlan {
      ...Named
      ...BidPackagesPage_AvailableUpdateProductOffering
    }
  }
  updateStats {
    tlivs {
      added
      removed
      updated
    }
    rplvs {
      added
      removed
      updated
    }
  }
}
    ${NamedFragmentDoc}
${BidPackagesPage_AvailableUpdateProductOfferingFragmentDoc}`;
export const AcceptBidPackageUpdatesDocument = gql`
    mutation AcceptBidPackageUpdates($input: AcceptBidPackageIncomingUpdatesInput!) {
  acceptBidPackageIncomingUpdates(input: $input) {
    id
  }
}
    `;

/**
 * __useAcceptBidPackageUpdatesMutation__
 *
 * To run a mutation, you first call `useAcceptBidPackageUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptBidPackageUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptBidPackageUpdatesMutation, { data, loading, error }] = useAcceptBidPackageUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptBidPackageUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptBidPackageUpdatesMutation, AcceptBidPackageUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptBidPackageUpdatesMutation, AcceptBidPackageUpdatesMutationVariables>(AcceptBidPackageUpdatesDocument, options);
      }
export type AcceptBidPackageUpdatesMutationHookResult = ReturnType<typeof useAcceptBidPackageUpdatesMutation>;
export type AcceptBidPackageUpdatesMutationResult = ApolloReactCommon.MutationResult<AcceptBidPackageUpdatesMutation>;
export const BidUpdatesAvailable_BidPackageDocument = gql`
    query BidUpdatesAvailable_BidPackage($id: ID!) {
  bidPackage(id: $id) {
    id
    name
    availableUpdates {
      ...BidPackagesPage_AvailableUpdate
    }
  }
}
    ${BidPackagesPage_AvailableUpdateFragmentDoc}`;

/**
 * __useBidUpdatesAvailable_BidPackageQuery__
 *
 * To run a query within a React component, call `useBidUpdatesAvailable_BidPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidUpdatesAvailable_BidPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidUpdatesAvailable_BidPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBidUpdatesAvailable_BidPackageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables> & ({ variables: BidUpdatesAvailable_BidPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>(BidUpdatesAvailable_BidPackageDocument, options);
      }
export function useBidUpdatesAvailable_BidPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>(BidUpdatesAvailable_BidPackageDocument, options);
        }
// @ts-ignore
export function useBidUpdatesAvailable_BidPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>;
export function useBidUpdatesAvailable_BidPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidUpdatesAvailable_BidPackageQuery | undefined, BidUpdatesAvailable_BidPackageQueryVariables>;
export function useBidUpdatesAvailable_BidPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>(BidUpdatesAvailable_BidPackageDocument, options);
        }
export type BidUpdatesAvailable_BidPackageQueryHookResult = ReturnType<typeof useBidUpdatesAvailable_BidPackageQuery>;
export type BidUpdatesAvailable_BidPackageLazyQueryHookResult = ReturnType<typeof useBidUpdatesAvailable_BidPackageLazyQuery>;
export type BidUpdatesAvailable_BidPackageSuspenseQueryHookResult = ReturnType<typeof useBidUpdatesAvailable_BidPackageSuspenseQuery>;
export type BidUpdatesAvailable_BidPackageQueryResult = ApolloReactCommon.QueryResult<BidUpdatesAvailable_BidPackageQuery, BidUpdatesAvailable_BidPackageQueryVariables>;